export enum ContactsAccessType {
    ContactAssignees,
    ContactGroups,
    ContactGenericInformations,
}
